/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './nutrition-order.reducer';

export const NutritionOrder = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const nutritionOrderList = useAppSelector(state => state.nutritionOrder.entities);
  const loading = useAppSelector(state => state.nutritionOrder.loading);
  const totalItems = useAppSelector(state => state.nutritionOrder.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="nutrition-order-heading" data-cy="NutritionOrderHeading">
        <Translate contentKey="tinyMedicRestApp.nutritionOrder.home.title">Nutrition Orders</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.nutritionOrder.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/nutrition-order/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.nutritionOrder.home.createLabel">Create new Nutrition Order</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.nutritionOrder.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {nutritionOrderList && nutritionOrderList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('recomendation')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.recomendation">Recomendation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recomendation')} />
                </th>
                <th className="hand" onClick={sort('mealType')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.mealType">Meal Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mealType')} />
                </th>
                <th className="hand" onClick={sort('mealStatus')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.mealStatus">Meal Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mealStatus')} />
                </th>
                <th className="hand" onClick={sort('orderStatus')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.orderStatus">Order Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('orderStatus')} />
                </th>
                <th className="hand" onClick={sort('feedType')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.feedType">Feed Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('feedType')} />
                </th>
                <th className="hand" onClick={sort('entralType')}>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.entralType">Entral Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('entralType')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.fulfilledBy">Fulfilled By</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.treatmentPlan">Treatment Plan</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.nutritionOrder.createdBy">Created By</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {nutritionOrderList.map((nutritionOrder, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/nutrition-order/${nutritionOrder.id}`} color="link" size="sm">
                      {nutritionOrder.id}
                    </Button>
                  </td>
                  <td>{nutritionOrder.microSec}</td>
                  <td>{nutritionOrder.timestampentry}</td>
                  <td>{nutritionOrder.lastupdated}</td>
                  <td>{nutritionOrder.cursor}</td>
                  <td>{nutritionOrder.active ? 'true' : 'false'}</td>
                  <td>{nutritionOrder.recomendation}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.MealType.${nutritionOrder.mealType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.MealStatus.${nutritionOrder.mealStatus}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.OrderStatus.${nutritionOrder.orderStatus}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.FeedType.${nutritionOrder.feedType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.EntralType.${nutritionOrder.entralType}`} />
                  </td>
                  <td>
                    {nutritionOrder.fulfilledBy ? (
                      <Link to={`/nutritionist/${nutritionOrder.fulfilledBy.id}`}>{nutritionOrder.fulfilledBy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {nutritionOrder.treatmentPlan ? (
                      <Link to={`/treatment-plan/${nutritionOrder.treatmentPlan.id}`}>{nutritionOrder.treatmentPlan.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {nutritionOrder.createdBy ? (
                      <Link to={`/doctor/${nutritionOrder.createdBy.id}`}>{nutritionOrder.createdBy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/nutrition-order/${nutritionOrder.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/nutrition-order/${nutritionOrder.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/nutrition-order/${nutritionOrder.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.home.notFound">No Nutrition Orders found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={nutritionOrderList && nutritionOrderList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default NutritionOrder;
